import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const fetchOpportunitiesSummary = createAsyncThunk(
  "fetchOpportunitiesSummary",
  async ({ page = 1, limit = 10, opportunity_id = '',person_id = '',financial_id = '' , status = ''}) => {
    const request = await api(`api/admin/opportunity-summary?page=${page}&limit=${limit}&opportunity_id=${opportunity_id}&person_id=${person_id}&financial_id=${financial_id}&status=${status}`, "", "get");
    return request;
  }
);

export const updateOpportunityJobStatus = createAsyncThunk(
  "updateOpportunityJobStatus",
  async ({ opportunity_id, status }) => {
    const request = await api(`api/admin/opportunity/jobstatus/${opportunity_id}`, { status }, "post");
    return request;
  }
);


const opportunitySummarySlice = createSlice({
  name: "invoices",
    initialState: {
      loading: false,
      success: null,
      error: null,
      totalCount: 0,
    },
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(fetchOpportunitiesSummary.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchOpportunitiesSummary.fulfilled, (state, action) => {
          state.invoices = action?.payload?.rows;
          state.totalCount = action?.payload.count;
          state.loading = false;
          state.error = null;
        })
        .addCase(fetchOpportunitiesSummary.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        .addCase(updateOpportunityJobStatus.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateOpportunityJobStatus.fulfilled, (state, action) => {
          state.loading = false;
          state.error = null;
        })
        .addCase(updateOpportunityJobStatus.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
    },
});
export default opportunitySummarySlice.reducer;
